import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputProps } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { PurchaseableSubjectStudentDto, State } from "../../interfaces";
import { SelectListDto } from "../../models";
import {
  getPurchaseableSubjectForStudent,
  resetPurchaseableSubjectForStudent,
} from "../../store/actions";

type TProps = InputProps & {
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  value: any;
  onChange: (values: any) => void;
  placeholder: string;
  courseId: string;
  gradeId: string;
  userId: string;
};

export const StudentPurchaseableSubjectsSelect: React.FC<TProps> = ({
  onChange,
  value,
  closeMenuOnSelect = true,
  isMulti = false,
  placeholder,
  courseId,
  gradeId,
  userId,
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { loading, error, response, success } = useSelector(
    (state: any): State<PurchaseableSubjectStudentDto[]> =>
      state.subject.purchaseableSubjectsForStudent
  );
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getData();

    return () => {
      dispatch(resetPurchaseableSubjectForStudent());
    };
  }, [courseId, gradeId, userId]);

  useEffect(() => {
    if (!loading && error)
      toast.error(error, {
        autoClose: 3000,
      });
  }, [loading]);

  const getData = () => {
    if (courseId && gradeId && userId) {
      dispatch(getPurchaseableSubjectForStudent(courseId, gradeId, userId));
    }
  };

  useEffect(() => {
    if (!loading && success && response) {
      var mappedOptions = response?.map(
        (item: PurchaseableSubjectStudentDto) => {
          return {
            label:
              i18n.language === "ar"
                ? item.subject.name.ar
                : item.subject.name.en,
            value: item.id,
          };
        }
      );
      setOptions(mappedOptions);
    }
  }, [loading, i18n.language]);

  return (
    <Select
      placeholder={t(placeholder)}
      closeMenuOnSelect={closeMenuOnSelect}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      options={options}
    />
  );
};
